/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_IndependentInputs */

const en_gc_home_independent = /** @type {(inputs: Gc_Home_IndependentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An independent guide, not affiliated with ArtCraft. GridCraft is in alpha; keep backups of important workbooks.`)
};

const zh_gc_home_independent = /** @type {(inputs: Gc_Home_IndependentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本站为独立指南，与 ArtCraft 无隶属关系。GridCraft 处于 Alpha 阶段，请备份重要工作簿。`)
};

/**
* | output |
* | --- |
* | "An independent guide, not affiliated with ArtCraft. GridCraft is in alpha; keep backups of important workbooks." |
*
* @param {Gc_Home_IndependentInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_independent = /** @type {((inputs?: Gc_Home_IndependentInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_IndependentInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_independent(inputs)
	return zh_gc_home_independent(inputs)
});
export { gc_home_independent as "gc.home.independent" }